<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSessionStore } from '@/stores/session.store'
import { useUiStore } from '@/stores/ui.store'

/**
 * Raíz. Sólo dos responsabilidades: instanciar los stores globales y decirle a
 * la sesión adónde ir cuando se pierde (el store no conoce el router).
 */
const session = useSessionStore()
const router = useRouter()

// Instanciar el store de interfaz aplica el tema guardado.
useUiStore()

session.onSessionLost(() => {
  const current = router.currentRoute.value
  if (current.meta?.public) return
  router.replace({ name: 'login', query: { redirect: current.fullPath, expired: '1' } })
})

onMounted(() => {
  document.documentElement.setAttribute('lang', document.documentElement.lang || 'es')
})
</script>

<template>
  <RouterView />
</template>
